import NavBar from "./Components/NavBar";
import ItemPanel from "./Components/ItemPanel";
import "./CSS/panel.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useState, useEffect } from "react";
import Prueba from "./Components/Prueba";
import { useParams, Link } from "react-router-dom";
import { getDoc, setDoc, doc } from "firebase/firestore";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./FirebaseConfig/firebase";
import { set } from "date-fns";

const MySwal = withReactContent(Swal);

function RegistroExitoso() {
  const navigate = useNavigate();
  const { id, idTicket } = useParams();

  const [salon, setSalon] = useState("");
  const [nombre, setNombre] = useState("");
  const [fecha, setFecha] = useState("");

  const [nombreParticipante, setNombreParticipante] = useState("");
  const [asientos, setAsientos] = useState("");
  const [fechaCompra, setFechaCompra] = useState("");
  const [comidas, setComidas] = useState("");
  const [nroTicket, setNroTicket] = useState("none");
  const [tipoEvento, settipoEvento] = useState("");
  const [lugar, setLugar] = useState("");
  const [invitados, setInvitados] = useState([]);

  const [datosCargados, setDatosCargados] = useState(false); // MOSTRAR BARRA DE CARGA

  //Funcion para mostrar detalles del evento
  const getEventoById = async () => {
    const evento = await getDoc(doc(db, "EVENTOS", id));

    if (evento) {
      setNombre(evento.data().nombre);
      setSalon(evento.data().salon);
      setFecha(evento.data().fecha);
	  settipoEvento(evento.data().tipoEvento);
	  setLugar(evento.data().salon)

    } else {
      console.log("no existe");
    }
  };

  //Funcion para mostrar detalles de la reserva
  const getEntradaById = async () => {
    const evento = await getDoc(
      doc(db, `EVENTOS/${id}/AsientosRegistrados`, idTicket)
    );
    if (evento) {
      setNombreParticipante(
        evento.data().nombre + " " + evento.data().apellidos
      );
      // ACA FALTA LLENAR CODIGOOOOOOOOOO
      setAsientos(evento.data().asientos);
      setFechaCompra(evento.data().fecha);
	  setInvitados(evento.data().invitados);
      let comida = `${
        evento.data().chancho ? "Chancho " + evento.data().chancho +" - " : ""
      }  ${evento.data().pollo ? " Pollo " + evento.data().pollo +" - " : ""}
	  ${evento.data().vegetariano ? "Vegetariano " + evento.data().vegetariano : ""}`;
      /*${evento.data().chancho}`
	  /*{row.chancho > 0 ? `Chancho:${row.chancho} ` : null}{" "}
                      {row.vegetariano > 0
                        ? `Vegeteriano:${row.vegetariano} `
                        : null}
                      {row.pollo > 0 ? `Pollo:${row.pollo} ` : null}{" "}*/
      setComidas(comida);
	  console.log("comida" + comida)
	  setNroTicket(evento.data().nroTicket);
	  setTimeout(() => {
		setDatosCargados(true);
		//console.log('Han pasado 2 segundos');
	  }, 500);

    } else {
      console.log("no existe");
    }
  };

  //cerrar agregar evento
  const cerrar = () => {
    if (localStorage.getItem("nivelUsuario") == "ingeniero") {
      navigate("../panelUser");
    } else {
      if (localStorage.getItem("nombreLocal") == "CIP") {
        navigate("../panelCDA");
      } else {
        if (localStorage.getItem("nivelUsuario") == "admin") {
          navigate("../panelAdmin");
        } else {
          navigate("../login");
        }
      }
    }
  };
  useEffect(() => {

	//console.log(tipoEvento);
	localStorage.setItem("codigocupon", null);
	localStorage.setItem("flagEntradas", false);
	localStorage.setItem("detallesRecibo", null);
	localStorage.setItem("cupon", false);
  }, [lugar]);
  useEffect(() => {

    getEntradaById();
    getEventoById();
    /*
    if (localStorage.getItem("idLocal") == "") {
      const idLocal = localStorage.getItem("idLocal");
      console.log("NO ES USER");
      navigate("../login");
    } else {
      setNombre(localStorage.getItem("nombreLocal"));
    }*/
  }, []);

  if (!datosCargados) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          margin: "0px auto",
          textAlign: "center",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div style={{ verticalAlign: "middle", display: "block" }}>
          <div>
            <img
              style={{ height: "300px" }}
              src={require(`./img/docucargando.gif`)}
              alt="esperando"
            />
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="panel">
      <NavBar
        titulo="Descarga Ticket"
        imagen="cerrar"
        logoTitulo="cupon"
        cerrar={cerrar}
      ></NavBar>
      <Prueba
        salon={salon}
        nombre={nombre}
        fecha={fecha}
        nombreParticipante={nombreParticipante}
        asientos={asientos}
        id={id}
        idTicket={idTicket}
        fechaCompra={fechaCompra}
        comidas={comidas}
		nroTicket={nroTicket}
		tipoEvento={tipoEvento}
		lugar={lugar}
		invitados={invitados}
		setDatosCargados={setDatosCargados}
      />
    </div>
  );
}

export default RegistroExitoso;
